import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginMutationRequest,
  PostApiLoginMutationResponse,
} from "../../../types/PostApiLogin";

export function getPostApiLoginUrl() {
  return `/api/Login` as const;
}

/**
 * {@link /api/Login}
 */
export async function postApiLogin(
  data?: PostApiLoginMutationRequest,
  config: Partial<RequestConfig<PostApiLoginMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
